import { FileType } from "ui/Scripts/source/models/enums";

export interface IDocumentFilePreview {
    fileType: FileType;
    path: string;
    text: string;
    html: string;
    errorMessage: string;
}

export class DocumentFilePreview implements IDocumentFilePreview {
    fileType: FileType;
    path: string;
    text: string;
    html: string;
    errorMessage: string;

    constructor();
    constructor(obj: IDocumentFilePreview);
    constructor(obj?: any) {
        this.fileType = obj && obj.fileType || FileType.Unknown;
        this.path = obj && obj.path || "";
        this.text = obj && obj.text || "";
        this.html = obj && obj.html || "";
        this.errorMessage = obj && obj.errorMessage || "";
    }
}
